import React from 'react';
import { testimonials } from '../data/content';
export function Testimonials() {
  return <section className="border-b border-line bg-ink py-16 md:py-24" aria-labelledby="testimonials-title" data-id="element-197" data-mp="3kpugtgqsmnhi">
      <div className="mx-auto max-w-6xl px-5 md:px-8" data-id="element-198" data-mp="3fyvxs9ef7bak">
        <h2 id="testimonials-title" className="font-display text-4xl font-extrabold uppercase text-white md:text-6xl" data-id="element-199" data-mp="3fxkt87d5hzie">
          What Coaches Are Saying
        </h2>
        <p className="mt-3 text-sm text-slate-300 md:text-base" data-id="element-200" data-mp="36wwefafxnv4g">
          <span className="text-gold" aria-hidden="true" data-id="element-201" data-mp="31z3ayp60lf7v">
            ⭐⭐⭐⭐⭐
          </span>{' '}
          4.9/5 · 500+ coaches across the USA and Latin America
        </p>

        <ul className="mt-10 grid gap-5 md:grid-cols-2 lg:grid-cols-3" data-id="element-202" data-mp="2s28cg69qretl">
          {testimonials.map(item => <li key={item.name} className="flex h-full flex-col rounded-xl border border-line bg-ink-800 p-6" data-id="element-203" data-mp="v8dljm0necce">
              <p className="text-sm text-gold" aria-label="5 out of 5 stars" data-id="element-204" data-mp="qbn5gyoufgqz">
                ⭐⭐⭐⭐⭐
              </p>
              <blockquote className="mt-3 text-sm leading-relaxed text-slate-200 md:text-base" data-id="element-205" data-mp="h4n2k87sbt9c">
                “{item.quote}”
              </blockquote>
              <p className="mt-auto pt-5 text-xs font-bold uppercase tracking-[0.12em] text-slate-400" data-id="element-206" data-mp="78aepqyx89mi">
                {item.name} — {item.location}
              </p>
            </li>)}
        </ul>
      </div>
    </section>;
}